<section *ngIf="alerts" aria-label="service alerts" role="status">
  <ul>
    <li class="service-notice" *ngFor="let alert of alerts">
      <p [innerHTML]="alert.display_message" role="alert"></p>
    </li>
  </ul>
</section>
